import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AssetManager from '../services/AssetManager';
import { useAuth } from '../contexts/AuthContext';

const SchoolHeader = ({ schoolInfo: propSchoolInfo }) => {
    const [schoolInfo, setSchoolInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { token } = useAuth();

    useEffect(() => {
        const fetchInstitutionData = async () => {
            try {
                setLoading(true);
                const assetManager = AssetManager.getInstance();
                const data = await assetManager.fetchInstitutionSettings();

                // Merge API data with prop data, using prop data as fallback
                setSchoolInfo({
                    name: data.name || propSchoolInfo?.name || "School Name",
                    logo: data.icon || propSchoolInfo?.logo || "https://via.placeholder.com/40",
                    website: data.website || propSchoolInfo?.website || "#",
                    urlEndpoint: data.url_endpoint || propSchoolInfo?.urlEndpoint || ""
                });
            } catch (err) {
                console.error('Error fetching institution data:', err);
                setError('Failed to load school information');
                // If API fails, use prop data or defaults
                setSchoolInfo({
                    name: propSchoolInfo?.name || "School Name",
                    logo: propSchoolInfo?.logo || "https://via.placeholder.com/40",
                    website: propSchoolInfo?.website || "#",
                    urlEndpoint: propSchoolInfo?.urlEndpoint || ""
                });
            } finally {
                setLoading(false);
            }
        };

        fetchInstitutionData();
    }, [propSchoolInfo]);

    if (loading) {
        return (
            <div className="py-4 px-6">
                <div className="max-w-7xl mx-auto flex items-center justify-between">
                    <div className="animate-pulse flex items-center space-x-4">
                        <div className="h-10 w-10 bg-gray-200 rounded"></div>
                        <div>
                            <div className="h-4 w-32 bg-gray-200 rounded"></div>
                            <div className="h-3 w-20 bg-gray-200 rounded mt-2"></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="py-4 px-6">
                <div className="max-w-7xl mx-auto">
                    <p className="text-red-600">{error}</p>
                </div>
            </div>
        );
    }

    const {
        name = "School Name",
        logo = "https://via.placeholder.com/40",
        website = "#",
        urlEndpoint = ""
    } = schoolInfo || {};

    const HeaderContent = () => (
        <div className="flex items-center space-x-4">
            <img
                src={logo}
                alt={`${name} logo`}
                className="h-14 w-14 object-contain"
            />
            <div>
                <h1 className="text-xl font-bold text-gray-900 uppercase">{name}</h1>
                <p className="text-sm text-gray-600">Schedule</p>
            </div>
        </div>
    );

    return (
        <div className="py-4 px-6">
            <div className="max-w-7xl mx-auto">
                {website && website !== "#" ? (
                    <a
                        href={website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:opacity-80 transition-opacity"
                    >
                        <HeaderContent />
                    </a>
                ) : (
                    <HeaderContent />
                )}
            </div>
        </div>
    );
};

export default SchoolHeader; 